import { BrowserBroadcast } from '@adapters/broadcast/browserBroadcast';
import { RedirectToExternalBankPage } from '@adapters/navigation/page';
import { Logger } from '@core/model/domain/logger';
import { Option } from '@core/model/framework/Result/Option';
import { Result } from '@core/model/framework/Result/Result';
import {
  ConnectionFormItemDto,
  RegionalBankPayload,
} from '@core/service/digital-factory/bank/types/dto/connectionFormDto';
import { GetWebauthUrl } from '@core/usecase/getWebauthUrl';

export type InitInput = {
  tagging: string | undefined;
  userToken: string;
  selectedBankUid: string;
  regionalBank: Option<RegionalBankPayload>;
};

export class RedirectToExternalBankVM {
  redirectToExternalBankPage: RedirectToExternalBankPage = 'REDIRECT_TO_EXTERNAL_BANK_WAIT';

  constructor(
    private getWebauthUrl: GetWebauthUrl,
    private broadcastService: BrowserBroadcast,
    private loggerService: Logger
  ) {}

  async onInit(initParams: InitInput) {
    this.closeOnWebauthReached();

    await this.updateExternalBankLoginUrl(initParams);
  }

  async updateExternalBankLoginUrl(params: InitInput) {
    try {
      let form: Option<ConnectionFormItemDto[]> = null;

      if (params.regionalBank?.value) {
        const { fieldName, websiteUrl } = params.regionalBank.value;
        form = { value: [{ name: fieldName, value: websiteUrl }] };
      }

      const getWebauthUrlPromise = this.getWebauthUrl.execute({
        tagging: params.tagging,
        userToken: params.userToken,
        bankId: params.selectedBankUid,
        form: form,
      });

      const waitAtLeast6Seconds: Promise<void> = new Promise((resolve) => {
        setTimeout(() => resolve(), 6000);
      });

      const result = await Promise.allSettled([getWebauthUrlPromise, waitAtLeast6Seconds]);

      if (result[0].status === 'rejected') {
        throw result[0].reason;
      }

      const url = Result.unwrap(result[0].value);
      window.document.location.replace(url);
    } catch (error) {
      this.loggerService.logException(error);
      this.redirectToExternalBankPage = 'REDIRECT_TO_EXTERNAL_BANK_ERROR';
    }
  }

  private closeOnWebauthReached(): void {
    this.broadcastService.getMessageFromLabel('WEBAUTH_POPUP_REACHED').subscribe(() => {
      window.close();
    });
  }
}
